import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { DELETE } from '../../api';

import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { DeleteDedicateFlashMessageRequest } from './deletededicateflashmessagesrequest';


export class DeleteDedicateFlashMessageAPI extends SixdeeCRBTAPI<DeleteDedicateFlashMessageRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return DELETE;
    }

    getAPIURL(): string
    { 
        return "flash/subscriber-management/subscribers/special-flash-messages-setting/" + this.getRequest().getId();
    }

    protected getRequestData() {
        return {
             "msisdn":this.getRequest().getMsisdn()
         };
     }

     getBASEURL(): string
     {
         return this.getContext().getProperty().getFlashURL() + 
             this.getAPIURL();
     }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/deletededicate/deletededicateflashmessagesapi.tsx